// Renders an imported `.svg` icon URL as a currentColor mask-icon (see `.tek-icon`
// in global.css), or passes a text glyph through unchanged. Used at render sites
// whose data arrays mix SVG icons with non-emoji text symbols (arrows, geometric
// bullets, ✓/✗). Icons are imported per use site as plain `.svg` files — this is a
// thin render switch, not a name-keyed icon registry.
export function iconNode(value, style) {
  if (typeof value === 'string' && value.endsWith('.svg')) {
    return (
      <span
        className="tek-icon"
        aria-hidden="true"
        style={style ? { ['--i']: `url("${value}")`, ...style } : { ['--i']: `url("${value}")` }}
      />
    );
  }
  return value;
}
